export const BackupSection = ({
    user,
    exportDataAsJson,
    jsonExchangeArea,
    setJsonExchangeArea,
    importDataFromJson
}) => {
    return (
        <section>
            {!user && (
                <div className="card p-6 space-y-4">
                <h3 className="font-extrabold text-slate-800 text-xs tracking-wider uppercase">데이터 백업/복구(수동)</h3>
                <button onClick={exportDataAsJson} className="w-full p-4 bg-indigo-50 text-indigo-600 rounded-2xl font-bold border border-indigo-100">데이터 복사</button>
                <textarea 
                    value={jsonExchangeArea} 
                    onChange={(e) => setJsonExchangeArea(e.target.value)} 
                    className="w-full h-32 bg-slate-50 rounded-2xl p-4 text-xs font-mono border-none resize-none" 
                    placeholder="JSON 붙여넣기" 
                />
                <button onClick={importDataFromJson} className="w-full bg-slate-900 text-white py-4 rounded-2xl font-bold">복구하기</button>
                </div>
            )}
        </section>
    );
}